module.exports = __webpack_public_path__ + "img/logoManancial.1b7cc79d.jpeg";